import { ThemingContext, InlineChildren, InlineChildrenSize, InlineChildrenAlignment, InlineChildrenJustification, Icon, IconType, IconSize, IconColor, Text, TextStyle, TextColor } from '@doordash/design-language';
import { FieldSize, FieldSizeSemantic } from '../constants.js';
import { ErrorIconWrapper } from './styles/ErrorMessage.js';
import React__default from 'react';
import { getThemeFieldTextStyles } from '../utils.js';

var ErrorMessageSize = FieldSize;

var ErrorMessage = function ErrorMessage(_ref) {
  var id = _ref.id,
      error = _ref.error,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? ErrorMessageSize.Medium : _ref$size;
  var theme = React__default.useContext(ThemingContext);
  var themeFieldErrorLineHeights = getThemeFieldTextStyles({
    theme: theme,
    size: size,
    styleType: 'Error'
  });
  return /*#__PURE__*/React__default.createElement(InlineChildren, {
    size: InlineChildrenSize.XxSmall,
    alignItems: InlineChildrenAlignment.FlexStart,
    justifyContent: InlineChildrenJustification.FlexStart,
    id: id,
    as: "span"
  }, /*#__PURE__*/React__default.createElement(ErrorIconWrapper // LineHeight props from theme are used to ensure that
  // the error Icon is center aligned with the first line
  // of error message text
  , {
    containerHeight: themeFieldErrorLineHeights.mobile.lineHeight,
    desktopContainerHeight: themeFieldErrorLineHeights.desktop.lineHeight
  }, /*#__PURE__*/React__default.createElement(Icon, {
    shouldAdjustSmallSizesWhitespace: true,
    type: IconType.WarningCircleFill,
    size: IconSize.Small,
    color: IconColor.TextError,
    accessibilityLabel: "Error"
  })), /*#__PURE__*/React__default.createElement(Text, {
    styles: TextStyle["".concat(FieldSizeSemantic[size], "Error")],
    color: TextColor.TextError
  }, error));
};

ErrorMessage.Sizes = ErrorMessageSize;

export { ErrorMessageSize, ErrorMessage as default };
